import CardsContainer from '../../../../components/common/cards/CardsContainer';
import { INewsItemEntry } from '../../../../contentful/types/INewsItemEntry';
import Card from '../../../../components/common/cards/Card/Card';
import { getListedEntryKey } from '../../../../utils/getListedEntryKey';
import { getCardImageSource } from '../../../../utils/getCardImageSource';
import { INewsSectionEntry } from '../../../../contentful/types/INewsSectionEntry';
import NewsSectionWrapper from '../../../news/section/ui/NewsSectionWrapper';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';

interface INewsSectionProps {
	id: string;
	section: INewsSectionEntry;
	addDarkBackground?: boolean;
}

export default function NewsSection({
	id,
	section,
	addDarkBackground,
}: INewsSectionProps) {
	const categoryLabels = section.fields.categories?.map(
		(category) => category.fields.categoryLabel,
	);

	const viewAllHref = categoryLabels
		? `${PageRoutes.CorporateNewsroomNews}/?category=${encodeURIComponent(
				categoryLabels.join(','),
		  )}`
		: PageRoutes.CorporateNewsroomNews;

	return (
		<NewsSectionWrapper
			id={id}
			title={section.fields.title}
			subtitle={section.fields.subtitle}
			addDarkBackground={addDarkBackground}
			viewAllHref={viewAllHref}
		>
			<CardsContainer columns={3}>
				{section?.fields?.items?.map((item: INewsItemEntry, index: number) => (
					<Card
						key={getListedEntryKey(item, index)}
						type="news"
						title={item.fields.title}
						imageSource={getCardImageSource(item.fields.image)}
						linkHref={`${PageRoutes.CorporateNewsroomNews}/item/${item.fields.slug}`}
						body={item.fields.body}
						imageAlt={item.fields.image?.fields.title || 'News card image'}
						publicationDate={item.fields.publicationDate}
						categories={item.fields.categories}
					/>
				))}
			</CardsContainer>
		</NewsSectionWrapper>
	);
}
